import { React, useState, useEffect, useRef } from 'react'
import "../css/ComponentStyle.css";
import "../css/PagesCommonStyle.css";
import { json, useLocation, useNavigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { Button } from 'bootstrap';
import { faCircleXmark, faCircleCheck, faPrint, faFlag, faGear, faFileInvoiceDollar, faFileLines } from '@fortawesome/free-solid-svg-icons'
import { faUser, faSquare } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRectangleList, faRightFromBracket, faBars } from '@fortawesome/free-solid-svg-icons'
import { CommonAPIConstants, APIConstants, LoginConstants } from '../utilities/Constants';
import { set } from 'date-fns';
import { useDispatch } from 'react-redux';
import { ClearDemoGraphyData } from '../redux/actions/userActions';
import { setAuthToken } from '../redux/actions/userActions';
import { faHouseChimney } from '@fortawesome/free-solid-svg-icons'
import "bootstrap-icons/font/bootstrap-icons.css";
import Sidebar from './Sidebar';



const StackedIcons = ({ isActive }) => {

  return (
    <span className={`fa-stack ${isActive ? "active-icon" : ""}`}>
      <FontAwesomeIcon icon={faRectangleList} style={{ fontSize: '1rem' }} className="fa-stack-2x" />
      <FontAwesomeIcon icon={faUser} style={{ marginRight: "25%", fontSize: "1rem" }} className="fa-stack-1x fa-inverse" />
    </span>
  );
};


const ReportIcons = ({ isActive }) => {

  return (
    <span className={`fa-layers fa-fw ${isActive ? "active-icon" : ""}`} style={{ fontSize: '1.2em' }}>

      <FontAwesomeIcon style={{ transform: 'scaleX(0.8)' }} icon={faSquare} />
      <FontAwesomeIcon style={{ fontSize: '0.9em' }} icon={faFileLines} transform="shrink-2 down-2 left-2" />
    </span>


  );
};




const DropdownMenu = ({
  icon,
  customIcon,
  options,
  activePage,
  handleMenuClick,
  openDropdown,
  handleDropdownToggle,
  menuName
}) => {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        if (openDropdown === menuName) {
          handleDropdownToggle(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openDropdown, menuName, handleDropdownToggle]);

  const isActive = options.some((option) => option.value === activePage);
  const isOpen = openDropdown === menuName;

  return (
    <li
      style={{ position: "relative", listStyle: "none", cursor: "pointer" }}
      onMouseEnter={() => handleDropdownToggle(menuName)}
      onMouseLeave={() => handleDropdownToggle(null)}
    >
      <div
        className={`dropdown-trigger ${isActive ? "active-icon" : ""}`}
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        {customIcon ? (typeof customIcon === "function" ? customIcon() : customIcon) : <FontAwesomeIcon icon={icon} className="nav-icons" />}
      </div>

      {isOpen && (
        <ul
          ref={dropdownRef}
          style={{
            position: "absolute",
            top: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
            borderRadius: "8px",
            padding: "10px 0",
            minWidth: "180px",
            listStyle: "none",
            zIndex: 9999,
            textAlign: "left"
          }}
        >
          {options.map((option, index) => (
            <li
              key={index}
              className={`dropdown-item ${activePage === option.value ? "active-icons" : ""}`}
              onClick={() => {
                handleMenuClick(option.value);
                handleDropdownToggle(null);
              }}
              style={{
                padding: "10px 16px",
                cursor: "pointer",
                fontSize: "0.9rem",
                fontWeight: "500",
                transition: "background-color 0.2s ease-in-out",
                whiteSpace: "nowrap"
              }}
            >
              <a
                style={{
                  color: "#333",
                  textDecoration: "none",
                  display: "block",
                  width: "100%",
                  height: "100%"
                }}
                onMouseEnter={(e) => (e.target.parentElement.style.backgroundColor = "skyblue")}
                onMouseLeave={(e) => (e.target.parentElement.style.backgroundColor = "transparent")}
              >
                {option.label}
              </a>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};






const Navbar = ({handleLogout}) => {


  const { id } = useParams();

  const dropdownRef = useRef(null);
  const userData = useSelector((state) => state.user.user);

  var userPracticeID = userData ? userData.practiceID : null;

  var userId = userData ? userData.userID : null;



  const navigate = useNavigate();

  const [newToken, setNewToken] = useState(null);


  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showClockModal, setShowClockModal] = useState(false);

  const [checkinStatus, setCheckinStatus] = useState(0);
  const [totalCheckinCount, setTotalCheckinCount] = useState(0);
  const [lastCheckout, setLastCheckout] = useState('');
  const [totalDuration, setTotalDuration] = useState('');
  const [duration, setDuration] = useState('00:00');
  const [firstCheckinTime, setFirstCheckinTime] = useState('');
  const [CheckOutTime, setCheckOutTime] = useState('');
  const [checkInStatusData, setCheckInStatusData] = useState('');
  const [checkOutStatus, setCheckOutStatus] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const [intervalId, setIntervalId] = useState(null);
  const [timerInterval, setTimerInterval] = useState(null);

  const [selectedSearchFilter, setSelectedSearchFilter] = useState('pat');
  const [searchText, setSearchText] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [lastSelectedItem, setLastSelectedItem] = useState(null);
  const [activePage, setActivePage] = useState(() => {
    return window.location.hash.replace("#/", "") || "";
  });

  const location = useLocation();
  const dispatch = useDispatch();

  const DemoGraphyData = useSelector((state) => state.user.demoDetails);


  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${month}/${day}/${year}`;
  };


  const defaultDate = getCurrentDate();




  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };







  const formatTime = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return `${hours}:${minutes} ${ampm}`;
  };





  const [currentTime, setCurrentTime] = useState(formatTime(new Date()));





  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(formatTime(new Date()));
    }, 1000);


    return () => clearInterval(interval);
  }, []);





  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsSidebarOpen(false);
      }
    };

    if (isSidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isSidebarOpen]);





  const incrementDuration = () => {
    const [minutes, seconds] = totalDuration.split(':').map(Number);
    const newSeconds = (seconds + 1) % 60;
    const newMinutes = minutes + (seconds + 1 >= 60 ? 1 : 0);
    setTotalDuration(
      `${String(newMinutes).padStart(2, '0')}:${String(newSeconds).padStart(2, '0')}`
    );
  };


  useEffect(() => {
    if (checkinStatus) {
      const interval = setInterval(incrementDuration, 60000);
      return () => clearInterval(interval);
    }
  }, [checkinStatus, totalDuration]);







//   const INACTIVITY_TIMEOUT = 20 * 60 * 1000;


// useEffect(() => {
//   let interval;

//   const resetTimer = () => {
//     localStorage.setItem('lastActivity', Date.now().toString());
//   };

//   const checkInactivity = () => {
//     const lastActivity = parseInt(localStorage.getItem('lastActivity') || '0', 10);
//     if (Date.now() - lastActivity > INACTIVITY_TIMEOUT) {
//       cleanup();
//       handleLogout();
//     }
//   };

//   const cleanup = () => {
//     events.forEach((event) => window.removeEventListener(event, resetTimer));
//     clearInterval(interval);
//   };

//   // Events that reset the inactivity timer
//   const events = ['mousemove', 'keypress', 'click'];
//   events.forEach((event) => window.addEventListener(event, resetTimer));

//   // Start the interval
//   interval = setInterval(checkInactivity, 1000);

//   // Initialize timer
//   resetTimer();

//   return () => {
//     cleanup();
//   };
// }, []);





//     useEffect(() => {
// if(userData) {
//         fetchNewToken();

//         const interval = setInterval(() => {
//             fetchNewToken();
//         }, 20* 60 * 1000); // 20 minutes

//         return () => clearInterval(interval);
//       }
//     }, [dispatch]);



    // useEffect(() => {
    //     if (newToken) {
    //         console.log("✅ AFTER 20 min Updated AuthToken:", newToken);
    //         dispatch(setAuthToken(newToken));
    //     }
    // }, [newToken, dispatch]);





    // const fetchNewToken = () => {


    //     var inputJSON = {

    //         UserName: userData.Username,
    //         PracticeId: userPracticeID,

    //     }

    //     var sJSONInput = JSON.stringify(inputJSON);
    //     console.log("input of" + LoginConstants.UpdatedToken, inputJSON);

    //     const url = `${APIConstants.SERVICES_URL}${LoginConstants.UpdatedToken}?sInputJSON=${sJSONInput}`;

    //     console.log("URL: ", url);

    //     fetch(url, {
    //         method: 'GET',
    //         headers: {
    //             'Accept': 'application/json',
    //             'Content-Type': 'application/json'
    //         }
    //     })

    //         .then((response) => {
    //             if (response.status != 200) { console.log("response.status", response.status); }
    //             else return response.json();
    //         })
    //         .then(data => {



    //             const parsedData = JSON.parse(data);

    //             setNewToken(parsedData.AuthToken)
               
    //             dispatch(setAuthToken(parsedData.AuthToken));
    //             console.log("✅Updated Token???????????????", parsedData);


    //         })
    //         .catch((error) => {
    //             console.error('Error fetching :', error);
    //         });
    // };






  const handleCloseModals = () => {
    // Close all modals

    setShowClockModal(false);
    setCheckOutStatus(false)

  };


  const handleOpenModal = () => {



    setShowClockModal(true);

  };




  const fetchUserClockStatus = () => {

    setShowClockModal(true)
    setCheckOutStatus(false)

    const objInput = {
      objTimeSheet: {
        isFromApp: 0,
        UserID: userData.userID,
        PracticeID: userPracticeID,
        DefaultTimeZoneOffSet: 300
      }
    };

    var myInput = JSON.stringify(objInput);

    const url = `${APIConstants.BASE_URL_TIMESHEET}${CommonAPIConstants.GetUserClockStatus}?sInputJSON=${myInput}`;
    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(resData => {

        const parsedData = JSON.parse(resData)

        console.log("tableData of  " + CommonAPIConstants.GetUserClockStatus, parsedData);


        setTotalCheckinCount(parsedData.TotalCheckinCount);
        //setTotalDuration(parsedData.TotalDuration);
        setDuration(parsedData.TotalDuration);
        setFirstCheckinTime(parsedData.FirstCheckinTime);
        setLastCheckout(parsedData.TotalCheckinCount == 0 ? '' : parsedData.LastCheckout);
        setCheckinStatus(parsedData.CheckinStatus);
        setCheckInStatusData(parsedData)


        localStorage.setItem("totalCheckinCount", JSON.stringify(parsedData.TotalCheckinCount));
        localStorage.setItem("duration", JSON.stringify(parsedData.TotalDuration));
        localStorage.setItem("firstCheckinTime", JSON.stringify(parsedData.FirstCheckinTime));
        localStorage.setItem("lastCheckout", parsedData.TotalCheckinCount == 0 ? '' : parsedData.LastCheckout);
        localStorage.setItem("checkinStatus", JSON.stringify(parsedData.CheckinStatus));
        localStorage.setItem("checkInStatusData", JSON.stringify(parsedData));



        setLoading(false);
      })
      .catch((error) => {
        console.error('API request failed', error);
        setLoading(false);
      });
  };




  useEffect(() => {
    if (location.pathname === '/Billingdasboard') {
      fetchUserClockStatus();
      dispatch(ClearDemoGraphyData());


    }
  }, [initialized, location.pathname]);








  useEffect(() => {
    const savedCheckinStatus = localStorage.getItem("checkinStatus");
    const savedTotalDuration = localStorage.getItem("totalDuration");
    const savedFirstCheckinTime = localStorage.getItem("firstCheckinTime");
    const savedCheckOutTime = localStorage.getItem("checkOutTime");
    const savedCheckOutStatus = localStorage.getItem("checkOutStatus");
    const savedLastCheckOut = localStorage.getItem("lastCheckout");

    if (savedCheckinStatus) setCheckinStatus(Number(savedCheckinStatus));
    if (savedTotalDuration) setTotalDuration(savedTotalDuration);
    if (savedFirstCheckinTime) setFirstCheckinTime(savedFirstCheckinTime);
    if (savedCheckOutTime) setCheckOutTime(savedCheckOutTime);
    if (savedCheckOutStatus) setCheckOutStatus(JSON.parse(savedCheckOutStatus));
    if (savedLastCheckOut) setLastCheckout(Number(savedLastCheckOut));

  }, []);




  const updateLocalStorage = () => {
    localStorage.setItem("checkinStatus", checkinStatus);
    localStorage.setItem("totalDuration", totalDuration);
    localStorage.setItem("firstCheckinTime", firstCheckinTime);
    localStorage.setItem("checkOutTime", CheckOutTime);
    localStorage.setItem("checkOutStatus", JSON.stringify(checkOutStatus));
    localStorage.setItem("lastCheckout", lastCheckout);
  };

  useEffect(() => {
    updateLocalStorage();
  }, [checkinStatus, totalDuration, firstCheckinTime, CheckOutTime, checkOutStatus, lastCheckout]);









  const fetchUserClockIn = () => {



    var today = new Date();

    var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();



    var UserDetails =
    {

      UserID: userData.userID,
      Lattitude: 0,
      Longitude: 0,
      CheckinoutTime: time,
      CheckinoutDate: date,
      isServerTime: 1,
      PracticeID: userPracticeID,
      DefaultTimeZoneOffSet: 300
    }


    var locString = JSON.stringify(JSON.stringify({ 'objTimeSheet': UserDetails }));


    const response = fetch(APIConstants.BASE_URL_TIMESHEET + CommonAPIConstants.GetUserClockIn, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: locString
    })

      .then((response) => response.json())
      .then((data) => {
        const parsedData = JSON.parse(data)

        // if (parsedData.CheckinStatus !== 0) {
        //   // Set a timeout to recheck status every 5 minutes if checked in
        //   setTimeout(fetchUserClockIn, 300000);
        // }


        setCheckinStatus(parsedData.CheckinStatus)
        setTotalDuration(parsedData.TotalDuration)
        setFirstCheckinTime(parsedData.FirstCheckinTime)

        setShowClockModal(false)

        localStorage.setItem("checkinStatus", parsedData.CheckinStatus);
        localStorage.setItem("totalDuration", parsedData.TotalDuration);
        localStorage.setItem("firstCheckinTime", parsedData.FirstCheckinTime);


      })
      .catch((error) => {
        console.error('Error fetching CPT names:', error);

      });
  };







  const fetchUserClockOut = () => {



    var today = new Date();

    var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();



    var UserDetails =
    {

      UserID: userData.userID,
      Lattitude: 0,
      Longitude: 0,
      CheckinoutTime: time,
      CheckinoutDate: date,
      isServerTime: 1,
      PracticeID: userPracticeID,
      DefaultTimeZoneOffSet: 300
    }


    var locString = JSON.stringify(JSON.stringify({ 'objTimeSheet': UserDetails }));



    const response = fetch(APIConstants.BASE_URL_TIMESHEET + CommonAPIConstants.GetUserClockOut, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: locString
    })

      .then((response) => response.json())
      .then((data) => {

        const parsedData = JSON.parse(data)


        //  setDuration(parsedData)
        setTotalDuration(parsedData[0].Duration)
        setFirstCheckinTime(parsedData[0].CheckinTime)
        setCheckOutTime(parsedData[0].CheckoutTime)
        setCheckinStatus(0)
        setCheckOutStatus(true)




        localStorage.setItem('clockInStatus', JSON.stringify({
          totalDuration: parsedData[0].Duration,
          firstCheckinTime: parsedData[0].CheckinTime,
          checkOutTime: parsedData[0].CheckoutTime,
          checkinStatus: 0,
          checkOutStatus: true
        }));

      })
      .catch((error) => {
        console.error('Error fetching:', error);

      });
  };




  const today = new Date();
  const dayName = today.toLocaleDateString('en-US', { weekday: 'long' });
  const date = today.toLocaleDateString('en-US');




  const formatDOSDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  };





  const handlePrint = () => {
    window.print();
  };



  const formatDOBDate = (dateString) => {
    if (!dateString) {
      return "";
    }


    const specificDate = new Date("01/01/1900");
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return "";
    }


    if (date.getTime() === specificDate.getTime()) {
      return "";
    }

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  };






  const fetchPatientNames = () => {


    var inputJSON = {
      PracticeID: userPracticeID,
      SearchKey: searchText,
      SearchBy: 0,
      isFromLogin: 0
    }

    var sJSONInput = JSON.stringify(inputJSON);
    const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllPatientNames}?sJSONInput=${sJSONInput}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {

        const parsedData = JSON.parse(data);
        const patientData = parsedData.Data;

        if (Array.isArray(patientData)) {
          setSuggestions
            (patientData.map((item) => ({
              label: `${item.LastName}, ${item.FirstName}`,
              val: item.PatientID,
            })));

        } else {


          setSuggestions([]);
          setSearchText('')

        }


      })
      .catch((error) => {
        console.error('Error fetching patient names:', error);
      });
  };






  const handleInputKeyPress = (event) => {
    if (event.key === 'Backspace') {

      if (searchText === '' && suggestions.length > 0) {
        setSuggestions([]);


      } else {
        // Remove the last character from searchText
        const updatedSearchText = searchText.slice(0, -1);
        setSearchText(updatedSearchText);


        fetchSuggestions(updatedSearchText);
      }
    } else if (event.key !== 'Enter') {
      // Handle other key presses
      setSearchText(event.target.value);
      fetchSuggestions(event.target.value);
    }
  };



  const fetchSuggestions = (text) => {

    if (selectedSearchFilter === 'pat') {
      fetchPatientNames(text);


    }


  };




  const handleSuggestionSelect = (item) => {

    setSearchText(item.label || item.val);
    setSuggestions([]);
    setSelectedItem(item.val)

    //navigate(`/patient-dashboard/${item.val}/primary-insurance`);
    //window.location.reload();
    // setTimeout(() => {
    //   navigate(`/patient-dashboard/${item.val}/primary-insurance`, { replace: true });
    // }, 0);

    window.open(`#/patient-dashboard/${item.val}/primary-insurance`)

    setSearchText('')


  };








  // const handleLogout = async () => {

  //   setLoading(true)

  //   const inpuJson = {
  //     UserID: userId,
  //     PracticeID: userPracticeID,

  //   }


  //   const sJSONInput = JSON.stringify(inpuJson);



  //   const url = `${APIConstants.SERVICES_URL}${LoginConstants.Logout}?sInputJSON=${sJSONInput}`;

  //   fetch(url, {
  //     method: 'POST',
  //     headers: {
  //       'Accept': 'application/json',
  //       'Content-Type': 'application/json'
  //     }
  //   })

  //     .then((response) => {
  //       if (response.status != 200) { console.log("response.status", response.status); }
  //       else return response.json();
  //     })
  //     .then(data => {



  //       const parsedData = JSON.parse(data);
  //       localStorage.clear();
  //       sessionStorage.clear();
  //       setTimeout(() => {

  //         localStorage.removeItem('activePage');
  //         localStorage.removeItem('userToken');

  //         navigate("/")
  //       }, 500);


  //     })
  //     .catch((error) => {
  //       console.error('Error fetching:', error);
  //     });
  // };







  function getAppLoactionLabelClass(appLocationName) {
    if (appLocationName === 'TP1' || appLocationName === 'TL3') {
      return 'applocation';
    } else if (appLocationName === 'Sec') {
      return 'applocation2';
    } else if (appLocationName === 'NE') {
      return 'applocation3';
    } else {
      return '';
    }


  }




  useEffect(() => {
    const handleHashChange = () => {
      setActivePage(window.location.hash.replace("#/", "") || "BillingDashboard");
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  const handleMenuClick = (pageName) => {
    window.open(`/#/${pageName}`, "_blank");

  };





  const menuOptions = [
    { value: "Claimapproval", label: "Approval" },
    { value: "MedicalClaimStatus", label: "Claim Status" },
    { value: "IntelliBill", label: "Intelli Bill" },
    { value: "LabBilling", label: "Lab Billing" },
    { value: "new-encounter", label: "New Encounter" },
    { value: "PostingPayments", label: "Posting Payments" },
    { value: "superbill", label: "Super Bill" },
    { value: "Upload-RemittanceFiles", label: "Remittance Upload" },
    { value: "workableclaims", label: "Workable Claims" },
    { value: "UpdateCPT", label: "Edit CPT" },

  ];


  const sortedOptions = menuOptions.sort((a, b) => a.label.localeCompare(b.label));



  const [openDropdown, setOpenDropdown] = useState(null);

  const handleDropdownToggle = (menuName) => {
    setOpenDropdown(openDropdown === menuName ? null : menuName);
  };




  // Check if the current route is the login page
  const isLoginPage = location.pathname === '/';

  if (isLoginPage) {
    return null; // Return null to hide the sidebar on the login page
  }




  const isLocPage = location.pathname === '/locations';

  if (isLocPage) {
    return null;
  }








  return (
    <>
      <div className='top-container ' >



        {DemoGraphyData && DemoGraphyData.MRN ? (
          <>

            <label className='pracnumber-style'>{userData.practiceFullID}</label>
            <label style={{ margin: '0px' }}>_</label>
            <label className={`pracloc-style ${getAppLoactionLabelClass(DemoGraphyData.LocationNickName)}`} style={{ fontSize: '1.1rem' }}>{DemoGraphyData.LocationNickName}</label>


          </>
        ) : (
          <>
            <label className='pracnumber-style'>{userData.practiceFullID}</label>

          </>
        )}
        <span style={{ color: 'gray', marginLeft: '5px' }}>|</span>
        <label className='username-style'>{userData.userFullName}</label>

        {checkinStatus == 0 ?

          <button className='clock-btn' onClick={fetchUserClockStatus}>Clock-in</button> :
          <button className='initial' onClick={fetchUserClockStatus}>
            {checkinStatus && <div>clock-in: {duration}</div>}
          </button>
        }

        {DemoGraphyData && DemoGraphyData.MRN && (
          <>
            <label className='username-style' style={{ marginLeft: '360px' }}>{DemoGraphyData.MRN || ""}</label>
            <span style={{ color: 'gray', marginLeft: '5px' }}>|</span>

            <label className='username-style' style={{ marginLeft: '10px' }}>{`${DemoGraphyData.LastName},${DemoGraphyData.FirstName}` || ""}</label>
            <span style={{ color: 'gray', marginLeft: '5px' }}>|</span>

            <label className='username-style' style={{ marginLeft: '10px' }}>{formatDOBDate(DemoGraphyData.DOB)}</label>
            <span style={{ color: 'gray', marginLeft: '5px' }}>|</span>

            <label className='username-style' style={{ marginLeft: '10px' }}>{DemoGraphyData.Age || ""} Years</label>
            <span style={{ color: 'gray', marginLeft: '5px' }}>|</span>

            <label className='username-style' style={{ marginLeft: '10px' }}>{DemoGraphyData.Gender || ""}</label>
            <span style={{ color: 'gray', marginLeft: '5px' }}>|</span>


            <label className='username-style' style={{ marginLeft: '10px' }}>  <FontAwesomeIcon onClick={handlePrint} icon={faPrint} /></label>
            <span style={{ color: 'gray', marginLeft: '5px' }}>|</span>



            <label style={{ marginLeft: '5px' }}><FontAwesomeIcon icon={faFlag} /></label>

          </>
        )}

        <button className='lg-out mt-3' >

          <FontAwesomeIcon style={{ fontSize: '2.4rem' }} icon={faRightFromBracket} onClick={handleLogout} />
        </button>



      </div>





      <div className='nav-container' style={{ display: 'flex' }}>


        <button
          style={{
            color: "white",
            background: "transparent",
            border: "1px solid whitesmoke",
            cursor: "pointer",
            marginLeft: "20px",
            borderRadius: "5px",
            fontSize: "1.1rem",
            width: '50px',
            height: '35px',
            marginTop: '3px'

          }}
          className="navbar-toggler"
          type="button"
          onClick={toggleSidebar}
          aria-label="Toggle navigation"
        >
          <FontAwesomeIcon style={{ fontSize: "1.3rem", padding: "2px" }} icon={faBars} className="navbar-toggler-icon" />
        </button>

        <div ref={sidebarRef}>
          <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        </div>




        <ul className='nav-icons'>
          <li>
            <FontAwesomeIcon
              className={` ${activePage === 'Billingdasboard' ? 'active-icon' : ''}`}
              onClick={() => handleMenuClick('Billingdasboard')}
              icon={faHouseChimney}
              style={{ marginLeft: '20px', marginTop: '5px' }}
            />
          </li>
          <li>
            <DropdownMenu
              activePage={activePage}
              icon={faFileInvoiceDollar}
              options={sortedOptions}
              handleMenuClick={handleMenuClick}
              openDropdown={openDropdown}
              handleDropdownToggle={handleDropdownToggle}
              menuName="invoice"
              style={{ margin: 0 }}
            />
          </li>
          <li>
            <DropdownMenu
              activePage={activePage}
              options={[{ value: "BillerPatientTracker", label: "Patient Tracker" }]}
              handleMenuClick={handleMenuClick}
              customIcon={() => <StackedIcons isActive={activePage === "BillerPatientTracker"} />}
              openDropdown={openDropdown}
              handleDropdownToggle={handleDropdownToggle}
              menuName="patientTracker"
            />
          </li>
          <li>
            <DropdownMenu
              activePage={activePage}
              options={[
                { value: "RHMAgingRecievedCharges", label: "AR Aging Report" },
                { value: "InsurancePaymentReport", label: "Insurance Payment Report" }

              ]}
              handleMenuClick={handleMenuClick}
              customIcon={() => <ReportIcons isActive={activePage === "InsurancePaymentReport"} />}
              openDropdown={openDropdown}
              handleDropdownToggle={handleDropdownToggle}
              menuName="InsurancePaymentReport"
            />
          </li>

          <li>
            <DropdownMenu
              activePage={activePage}
              icon={faGear}
              options={[{ value: "MedicalClaimMacro", label: "Macro" }]}
              handleMenuClick={handleMenuClick}
              openDropdown={openDropdown}
              handleDropdownToggle={handleDropdownToggle}
              menuName="macro"
            />
          </li>

        </ul>


        {loading && (
          <div className="overlay">
            <div className="spinner-container">
              <div className="spinner-grow text-danger" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="spinner-grow text-warning" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="spinner-grow text-info" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        )}



        {DemoGraphyData && DemoGraphyData.MRN ? (

          <>
            <label className='username-style' style={{ marginLeft: '600px', fontSize: '1.1rem', fontWeight: 'bold', width: '80px' }}>
              {dayName}
            </label>

            <label className='username-style' style={{ marginLeft: '10px' }}>
              {date}
            </label>
          </>
        ) : (

          <label style={{ marginLeft: '780px', fontSize: '1.1rem', fontWeight: 'bold', width: '80px' }}>

          </label>
        )


        }



        <div style={{ display: 'flex', marginTop: '5px', marginLeft: '200px' }}>

          <label style={{ color: 'white', width: '80px' }}>Search By :</label>
          <select name="select" style={{ width: '110px', height: '30px', color: 'black', marginLeft: '10px', borderRadius: '5px' }}
            value={selectedSearchFilter}
            onChange={(e) => setSelectedSearchFilter(e.target.value)}>

            <option value="pat">Name</option>
            <option value="phone">Phone</option>
            <option value="mrn">MRN</option>

          </select>



          <div style={{ marginLeft: '10px' }}>
            <input
              type='text'
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={handleInputKeyPress}
              placeholder='Search Patient'
              style={{ width: '150px', height: '30px', borderRadius: '5px', }}
            />
            <div className='autocomplete-style' style={{ zIndex: '10' }} >
              <ul className='list-style' style={{ width: '160px', fontSize: '1rem', position: 'absolute' }}>
                {suggestions.map((suggestion) => (
                  <li key={suggestion.val} value={suggestion.val} onClick={() => handleSuggestionSelect(suggestion)}>{suggestion.label}</li>
                ))}
              </ul>
            </div>
          </div>

        </div>






        {showClockModal && (
          <>


            <div className='msgcheckinPopUp'>
              <FontAwesomeIcon icon={faCircleXmark} style={{ color: 'brown', float: 'right', }} onClick={handleCloseModals} />
              <label className='checkinoutcurdate mt-4'>{defaultDate} {currentTime}</label>
              <label className='checkinpopupcnfmsg'>{checkinStatus == 0 ? "You are not checked in!" : "You are checked in!"}</label>


              <div className='checkinpopupmsg'>
                <div className='d-flex'>
                  {checkinStatus == 0 ?
                    <FontAwesomeIcon icon={faCircleXmark} className='Usercheckout' /> :
                    <FontAwesomeIcon icon={faCircleCheck} className='Usercheckin' />
                  }
                  <div>
                    <label style={{ marginLeft: '80px' }}>{firstCheckinTime}</label>
                    <br />

                    <div>
                      <label style={{ marginLeft: '20px' }}>{duration}</label>
                    </div>
                  </div>
                </div>

                {checkinStatus == 0 ?
                  <button className="clock-btn" onClick={fetchUserClockIn}>
                    Clock-in

                  </button> :

                  <button className="clock-btn" onClick={fetchUserClockOut}>
                    Clock-out

                  </button>
                }

              </div>

            </div>



            {checkOutStatus &&
              <div className='msgcheckinPopUp'>
                <FontAwesomeIcon icon={faCircleXmark} style={{ color: 'brown', float: 'right', }} onClick={handleCloseModals} />
                <label className='checkinoutcurdate mt-4'>{defaultDate} {currentTime}</label>
                <label className='checkinpopupcnfmsg'>You are checked Out!</label>


                <div className='checkinpopupmsg'>
                  <div className='d-flex'>

                    <FontAwesomeIcon icon={faCircleXmark} className='Usercheckout' />

                    <div>
                      <label style={{ marginLeft: '10px' }}>Clock-in Time:{firstCheckinTime}</label>
                      <br />

                      <div>
                        <label style={{ marginLeft: '0px', fontSize: '2rem' }}>Clock-out Time:{CheckOutTime}</label>
                      </div>

                      <div>
                        <label>{totalDuration}</label>
                      </div>
                    </div>
                  </div>



                </div>


              </div>

            }
          </>

        )}

      </div>





    </>
  )
}

export default Navbar